import React from 'react';
import { useAccessSharingFlowContext } from 'app/hooks/access-sharing';
import { ACCESS_SHARING_FLEET_STEPS } from 'app/constants/access-sharing';
import { FleetCreatedView } from 'app/components/access-sharing/flows';
import { useTranslation } from 'react-i18next';

interface Props {
  selectedEquipmentName: string;
  onBack: () => void;
}

export default function EquipmentAddedStepController({
  selectedEquipmentName,
  onBack,
}: Props) {
  const { t } = useTranslation();

  const { stepper, selectedFleetName, selectedEquipmentIds } =
    useAccessSharingFlowContext();
  const { setStep } = stepper;

  function handleNextStep() {
    setStep(ACCESS_SHARING_FLEET_STEPS.ACCESS_SHARING);
  }

  return (
    <FleetCreatedView
      title={t('access_sharing.flows.fleet_selection.equipment_added', {
        equipment: selectedEquipmentName,
        fleet: selectedFleetName,
      })}
      selectedEquipmentIds={selectedEquipmentIds}
      onBack={onBack}
      onNextStep={handleNextStep}
    />
  );
}
